define(function(require, exports, module) {
    'use strict';

    var $ = require('common/j');

    /**
     * Returns offsetHeight of first element;
     * @type {Function}
     * @return number
     */
    $.fn.getHeight = function() {
        var height = this[0] && this[0].offsetHeight;
        return height || 0;
    };

    /**
     * Calculates offset from parent element (defaults to `body`)
     * @type {Function}
     * @return {{top: number, left: number}}
     */
    $.fn.offset = function() {
        var childRect = this[0] && this[0].getBoundingClientRect();
        childRect = childRect || { top: 0, left: 0 };
        return {
            top: childRect.top + window.scrollY,
            left: childRect.left + window.scrollX
        };
    };

    module.exports = $;
});
